// Group drawer helpers: role options, toAdminAccess (builds the adminAccess body), hasAdminAccessChanged and save toast copy.
import { AdminRoleOptions, CONVERSATION_ACCESS_PERMISSION } from '@/lib/models/admin-user.model';
import { GroupAdminAccess, GroupModel, NO_ADMIN_ROLE } from '@/lib/models/group.model';
import { UiOption } from '@/lib/helpers';

export const GroupAdminRoleOptions: UiOption[] = [
  { value: NO_ADMIN_ROLE, label: 'None' },
  ...AdminRoleOptions,
];

// A null result clears the mapping.
export const toAdminAccess = (
  role: string,
  conversationAccess: boolean
): GroupAdminAccess | null => {
  const hasRole = !!role && role !== NO_ADMIN_ROLE;

  if (!hasRole && !conversationAccess) {
    return null;
  }

  const permissions = conversationAccess ? [CONVERSATION_ACCESS_PERMISSION] : [];

  if (!hasRole) {
    return { permissions };
  }

  return { role, permissions };
};

export const hasAdminAccessChanged = (
  saved: Pick<GroupModel, 'adminRole' | 'adminConversationAccess'>,
  edited: Pick<GroupModel, 'adminRole' | 'adminConversationAccess'>
): boolean =>
  saved.adminRole !== edited.adminRole ||
  saved.adminConversationAccess !== edited.adminConversationAccess;

export const GROUP_UPDATED_TOAST = 'The group was updated';
export const GROUP_ADMIN_ACCESS_SAVED_TOAST =
  'The group was saved. Changes to Admin Users can take a few minutes to apply.';
